
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"15.998 9.999 7.002 14.002\" id=\"icon-facebook_small\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M22.885,17.469h-2.526v6.532h-2.574v-6.532h-1.787v-2.378h1.787c0,0,0-0.975,0-2.031\r\n\tc0-1.596,1.056-3.061,3.489-3.061c0.985,0,1.714,0.092,1.714,0.092l-0.057,2.221c0,0-0.743-0.008-1.554-0.008\r\n\tc-0.877,0-1.017,0.395-1.017,1.051c0,0.098,0,0.119,0,0.109c0,0.18,0,0.62,0,1.627H23L22.885,17.469z\"/> </symbol>";
module.exports = sprite.add(image, "icon-facebook_small");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/facebook_small.svg
 ** module id = 176
 ** module chunks = 24
 **/